import axios from 'axios';
import Cookies from 'js-cookie';
import AuthService from '../services/AuthService';
import authHeader from '../services/auth-header';
const ENDPOINTS = 'apis/subscription/v1/login';
const USER_API_URL = process.env.REACT_APP_BASE_URL;

const authAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    // withCredentials: true,

});
authAxios.interceptors.request.use(
    config => {
        config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("AuthInfo");
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

let isRefreshing = false; // Flag to track if a refresh is in progress
let refreshSubscribers = []; // Queue to store requests while refreshing

// Function to add subscribers (requests waiting for a new token)
function subscribeTokenRefresh(callback) {
    refreshSubscribers.push(callback);
}

// Function to notify all waiting requests with the new token
function onTokenRefreshed(token) {
    refreshSubscribers.forEach((callback) => callback(token));
    refreshSubscribers = []; // Clear the queue after notifying
}

// Axios response interceptor to handle token expiration
authAxios.interceptors.response.use(
    (response) => response, // Successful response
    async (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            if (!isRefreshing) {
                // Refresh token logic
                isRefreshing = true;
                // const refreshToken = Cookies.get('refreshToken');
                try {
                    const newAccessToken = await refreshToken();
                    if (newAccessToken) {
                        originalRequest._retry = true;
                        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                        // Retry the original request with the new access token
                        onTokenRefreshed(newAccessToken); // Notify all waiting requests
                        return axios(originalRequest);
                    }
                } catch (error) {
                    console.error('Refresh token expired or invalid');
                    window.location.href = '/'; // Redirect to login page if refresh fails
                } finally {
                    isRefreshing = false;
                }
            }
            console.log("newToken okkkk222== ");
            // If the token is still being refreshed, subscribe to the refresh
            return new Promise((resolve) => {
                console.log("newToken okkkk== ");

                subscribeTokenRefresh((newToken) => {
                    console.log("newToken == ", newToken);
                    originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                    resolve(axios(originalRequest));
                });
            });
        }
        console.log("newToken okkkk3333== ");
        return Promise.reject(error);
    }
);

// Function to refresh the token using the refresh token
const refreshToken = async () => {
    const refreshToken = Cookies.get('refreshToken');

    if (!refreshToken) {
        console.error('Refresh token is missing, redirecting to login...');
        return AuthService.getAuth();
    }

    console.log("refreshToken == ", refreshToken);
    try {
        const response = await authAxios.post("/apis/subscription/v1/refresh", {}, {
            headers: {
                Authorization: `Bearer ${refreshToken}`,
            }
        });
        console.log("refresh response = ", response.data);
        const { token } = response.data;
        // Store the new access token in sessionStorage
        sessionStorage.setItem('AuthInfo', token);
        return token;
    } catch (error) {
        console.error('Error during refresh token request: ', error);
        
        return AuthService.getAuth();
    }
};

class UserService {

    generateOtp (mobileNum, source, utm_source, customer_mobile, fresh_user, onBooking)
     {
           return authAxios.post( `/apis/subscription/v1/login/generate-otp`, {
            mobileNum,
            source,
            utm_source,
            customer_mobile,
            fresh_user,
            onBooking
            
        })
            .then(response => {
                return response.data;
            }).catch(error => {
                console.log('error', error)
              });
    }
    generateFreshUserOtp (mobileNum, source,fresh_user) 
    {
          return authAxios.post( `/apis/subscription/v1/login/generate-otp`, {
           mobileNum,
           source,
           fresh_user
           
       })
           .then(response => {
               return response.data;
           });
    }

    generateFreshMobOtp (mobileNum, source) 
    {
        return authAxios.post( `/apis/subscription/v1/login/generate-otp-fresh`, {
           mobileNum,
           source
        }).then(response => {
            return response.data;
        }).catch(err => {
            console.log('error', err);
            if (err && err.response && err.response.data) {
                if (err.response.status === 429) {
                    return{
                        success: false,
                        message: "You have request for OTP multiple times. Please try after 30 minutes.",
                    };
                } else if(err.response.status === 404) {
                    if(err?.response?.data?.message  === "Mobile number does Not exists"){
                        return{
                            success: false,
                            message: `${err.response.data.message || "Something went wrong!"}`,
                        };
                    }else{
                        return{
                            success: false,
                            message: `${err.response.data.message || "Something went wrong!"}`,
                        };
                    }
                
                } else {
                    return{
                        success: false,
                        message: `${err.response.data.message || "Something went wrong!"}`,
                    };
                }
            } else {
                return{
                    success: false,
                    message: "Something went wrong!",
                };
            }
        });
    }

    generateFreshEamilOtp (email, source) 
    {
        return authAxios.post( `/apis/subscription/v1/login/generate-otp-email`, {
           email,
           source
        }).then(response => {
            return response.data;
        }).catch((err) => {
            console.error("Error in generateFreshEamilOtp:", err);
            if (err && err.response && err.response.data) {
                if (err.response.status === 429) {
                    return{
                        success: false,
                        message: "You have entered incorrect OTP multiple times. Please try after 30 minutes.",
                    };
                } else {
                    return{
                        success: false,
                        message: `${err.response.data.message || "Something went wrong!"}`,
                    };
                }
            } else {
                return{
                    success: false,
                    message: "Something went wrong!",
                };
            }
        });
    }

   verifiyAcqFreshUserOtp (mobile, source,otp,scheme_id,pincode) 
   {
         return authAxios.post( `/apis/subscription/v1/login/fresh-user`,{
          mobile,
          source,
          otp,
          scheme_id,
          pincode
          
      })
          .then(response => {
              return response.data;
          });
    }

    addDeliveryEmailAdress(order_id, flat_no,floor,block_or_street,city,state,pin_code,locality_non_master,society_non_master,email,customer_name,initiator) 
    {
          return authAxios.post( `/apis/subscription/v1/orders/update-address`,{
            order_id,
            flat_no,
            floor,
            block_or_street,
            city,
            state,
            pin_code,
            locality_non_master,
            society_non_master,
            email,
            customer_name,
            initiator
       })
           .then(response => {
               return response.data;
           });
     }

     paymentTransaction(
        link_id, 
        price, 
        mobile, 
        scheme_id, 
        order_id, 
        gateway, 
        user_email, 
        scratch_card_code, 
        lead_id, 
        utm_source = null, 
        utm_campaign=null, 
        gift_id=null
    )
     {
           return authAxios.post( `/apis/subscription/v1/reNewScheme/payments/fetchAllPayment`,{
            link_id,
            price,
            mobile,
            scheme_id,
            order_id,
            gateway,
            user_email,
            scratch_card_code,
            lead_id,
            utm_source,
            utm_campaign,
            gift_id
        })
            .then(response => {
                return response.data;
            });
      }

    verifyAcqFreshPinCodeEligibility(pincode,schemeId,source,forInstitutional=false) 
    {
        return authAxios.get( `/apis/subscription/v1/home/schemes/is-product-eligible?pincode=`+pincode+`&schemeId=`+schemeId +`&source=`+source+`&forInstitutional=`+forInstitutional)
    }

    async getSSOTrueCaller(token) 
    {
        return await authAxios.get( `/apis/subscription/v1/login/sso-user-data?token=`+token)
    }

    getWhatsappNotification(mobileNumber) 
    {
        return authAxios.get( `/apis/subscription/v1/whatsapp-integration?method=OPT_IN&mobile=`+mobileNumber)
    }

    verifyScratchCouponDetails(couponCode,schemeId,mobileNum) 
    {
        return authAxios.get( `apis/subscription/v1/reNewScheme/payments/get-scratch-card-details?code=`+couponCode+`&scheme_id=`+schemeId+`&mobile=`+mobileNum)
    }

    verifyPreAuthRedirection(unique_code) 
    {
        return authAxios.get( `/apis/subscription/v1/auto-login?unique_code=` + unique_code);
    }

    verifiyOtp(otp, mobile, source="SSP") {
        // const source = "SSP";
        return authAxios.get( `/apis/subscription/v1/login/verifyOtp?source=` + source + `&mobile=` + mobile + `&otp=` + otp);
    }
    
    verifiyOtpFresh(otp, mobile, source="SSP") 
    {
        return authAxios.post( `/apis/subscription/v1/login/verify-otp-email`, ({
            "source": source,
            "email": mobile,
            "otp": otp,
           
        }));
    }
    getAllowedSchemes(salesOrg, orderCode, accountId) {
        return authAxios.get( `/apis/subscription/v1/home/schemes/get-allowed-schemes?sales_org=` + salesOrg + `&scheme=` + orderCode + `&accountId=` + accountId);

    }

    getExistingCustomerSchemes(accountId, schemeType = false, utmSourceName = null) {
        let url = `/apis/subscription/v1/home/schemes/get-existing-customer-schemes?accountId=${accountId}&forInstitutional=${schemeType}`;
        const cleanUtmSourceName = String(utmSourceName).trim();
        if (cleanUtmSourceName != null && cleanUtmSourceName.trim() !== "") {
            url += `&subChannel=${encodeURIComponent(cleanUtmSourceName)}`;
        }
    
        return authAxios.get(url);
    }    

    getPaymentByLinkId(linkId) {
        return authAxios.get( "/apis/subscription/v1/reNewScheme/payments/getPaymentByLinkId/" + linkId);

    }
    fetchOrders(accountId) {

        return authAxios.get( "/apis/subscription/v1/orders/get-all-orders/" + accountId);

    }

    acqSubscriptionDetails(forInstitutional=false) {
        return authAxios.get( `/apis/subscription/v1/fresh?forInstitutional=${forInstitutional}` );
    }
    couponDetails(accountId, publication, source, orderId=null) {
        return authAxios.get( "/apis/subscription/v1/coupons/get-all-coupons/" + accountId + "/" + publication + "/" + source, {
            params: {
                orderId: orderId
            }
        });
        // return axios.get("http://localhost:8083/apis/subscription/v1/coupons/get-all-coupons/0011s00000A2CMmAAN/HH");
    }
    updateEmail(email, mobile) {
        return authAxios.patch( `/apis/subscription/v1/update-email?email=` + email + `&mobile=` + mobile);
    }

    fetchAccountInfo(mobile) {
        return authAxios.get( `/apis/subscription/v1/get-account-details?mobile=` + mobile);
    }

    validOrderOnDigital(email, mobile) {
        return authAxios.get( `/apis/subscription/v1/login/validate-subscription?email=${email}&mobileNum=${mobile}`);
    }

    fetchOrderStages(orderID) {
        return authAxios.get( `/apis/subscription/v1/stages/${orderID}`);
    }

    fetchPaymentGatewayInfo(territoryId, publication, paymentMode, gateway) {
        return authAxios.get( `/apis/subscription/v1/reNewScheme/payments/getGatewayInfo/` + territoryId + `/` + publication + `/` + paymentMode + `/` + gateway);
    }
    redeemedCoupons(vendorId, couponInfo, source, mobile,vendorUpdated, accountId,otp) {
        return authAxios.post( `/apis/subscription/v1/coupons/redeem-coupons`, ({
            "vendor_id": vendorId,
            "source": source,
            "mobile": mobile,
            "coupons": couponInfo,
            "vendor_updated": vendorUpdated,
            "account_id": accountId,
            "redemption_source": "SSP",
            "otp": otp
        }));
    }

    releaseCoupons(source,mobile,otp,couponInfo,vendorId,is_released) 
    {
        return authAxios.post( `/apis/subscription/v1/coupons/release-coupons`, ({
            "source": source,
            "mobile": mobile,
            "otp": otp,
            "coupons": couponInfo,
            "vendor_id":vendorId,
            "is_released":is_released
           
        }));
    }

    updateVendor(vendorInfo, accountInfo, otp, mobile, source) 
    {
        return authAxios.post( `/apis/subscription/v1/external-partner/update-customer-vendor`, ({
            "vendor_id": vendorInfo,
            "account_id": accountInfo,
            "otp": otp,
            "mobile": mobile,
            "source": source
        }));
    }

    getLocalities(salesOrg, searchTerm) {
        return authAxios.get(`/apis/subscription/v1/get-localities?sales_org=` + salesOrg + `&city=` +`&search_key=`+ searchTerm);
    }

    getSocieties(localityId) {
        return authAxios.get( `/apis/subscription/v1/get-societies?locality_id=` + localityId);
    }

    updateAddress(addressDetails, accountId, description) {
        return authAxios.post(`/apis/subscription/v1/case/create-case`, ({
            "source":"SSP",
            "new_address": addressDetails,
            "account_id": accountId,
            "description": description
        }));
    }

    createComplain(payload) {
        return authAxios.post(`/apis/subscription/v1/case/create-complain`, ({
            "typeId": payload.typeId,
            "subTypeId": payload.subTypeId,
            "accountId": payload.accountId,
            "ciId": payload.ciId,
            "description": payload.description,
            "orderId": payload.orderId
        }));
    }

    getAllComplaints(account_id) {
        return authAxios.get(`/apis/subscription/v1/case/complain-listing/${account_id}`);
    }
    getCaseTyps() {
        return authAxios.get(`/apis/subscription/v1/case/case-picklist`);
    }
    
    getVenderDetails(accountId, mobile) {
        return authAxios.get( `/apis/subscription/v1/external-partner/change-vendor/` + accountId + `/` + mobile + `/` + "SSP");

    }
    createOrder(txnId, amountScheme, schemCode, accountId, orderId, name, emailId, mobileNum, salesOrg) {
        // const dt = JSON.stringify({
        //     "data": {
        //         "customer_name": name,
        //         "mobile": mobile,
        //         "email": email,
        //         "scheme": schemCode,
        //         "source": "SSP",
        //         "transaction_id": txnId,
        //         "amount": amount,
        //         "sales_org": salesOrg,
        //         "is_address_filled": false,
        //         "order": orderId,
        //         "account": accountId
        //     }
        // });

        const customer_name = name;
        const mobile = mobileNum;
        const email = emailId;
        const scheme = schemCode;
        const source = "SSP";
        const transaction_id = txnId;
        const amount = amountScheme;
        const sales_org = salesOrg;
        const is_address_filled = false;
        const order = orderId;
        const account = accountId;
        return authAxios.post( `/apis/subscription/v1/order/create-order`,
            {
                customer_name,
                mobile,
                email,
                scheme,
                source,
                transaction_id,
                amount,
                sales_org,
                is_address_filled,
                order,
                account
            })


    }

    getPaymentOffers(gateway) {
        return authAxios.get( `/apis/subscription/v1/getoffers/` + gateway);
    }

    addNewLeadGenerate(mobile, schemeId, utmSource, forInstitutional=false, utm_campaign=null, gift_id=null) {
        return authAxios.post( `/apis/subscription/v1/order/add-lead-initial`, ({
            "mobile": mobile,
            "scheme_id": schemeId,
            "utm_source": utmSource,
            "initiator": "acquisition_journey",
            "for_institutional": forInstitutional,
            "utm_campaign": utm_campaign,
            "gift_id": gift_id
        }));
    }

    existingCustomerLeadGenerate = async (accountId, schemeId, forInstitutional=false, utmSource='', utmCampaign='', giftId='') => {
        return authAxios.post(`/apis/subscription/v1/order/recreate?accountId=${accountId}&schemeId=${schemeId}&forInstitutional=${forInstitutional}&utmSource=${utmSource}&utmCampaign=${utmCampaign}&giftId=${giftId}`);
    };
    

    addDeliveryAdress(dataObj) 
    {
        return authAxios.post( `/apis/subscription/v1/orders/update-address`,dataObj)
        .then(response => {
            return response.data;
        });
    }

   getUserConsent(accountId) {
        return authAxios.get( `/apis/subscription/v1/user-consents/get`, ({
            params: {
                "userId": accountId,
                "medium": 2
            }
        })).then(response => {
            return response;
        }).catch(error => {
            console.log('getUserConsent error', error)
        });
   }

   insertUserConsent(accountId, piConsent=true, cookieConsent=true) {
        return authAxios.post( `/apis/subscription/v1/user-consents/insert`, ({
            "userId": accountId,
            "piConsent": piConsent,
            "cookieConsent": cookieConsent,
            "medium": 2
        })).then(response => {
            return response;
        }).catch(error => {
            console.log('insertUserConsent error', error)
        });
   }

    downloadBookingFormPDF(leadId) {
        return authAxios.get(`/apis/subscription/v1/booking-form/download-booking-form-pdf/${leadId}`, {
            responseType: 'blob' // Important: This tells axios to expect binary data
        });
    }

    getBookingFormUrl(leadId) {
        return authAxios.get(`/apis/subscription/v1/booking-form/get-booking-form-url/${leadId}`);
    }
}

export default new UserService();
